import Constants from "../constants/constants";
import { httpGet, httpPost } from "./api/axios_api";

export const actions = {
  gotFunctionalSkills: "GOT_FUNCTIONAL_SKILLS",
  startedNewSkillSession: "STARTED_NEW_SKILL_SESSION"
};

export async function getFunctionalSkills(token) {
  let url = `${Constants.BACKEND_URL}/get-functional-skills/`;
  return httpGet(url, {}, token);
}

export async function startNewFunctionalSkillSession(functionalSkillID, token) {
  let url = `${Constants.BACKEND_URL}/start-new-functional-skill-session/`;
  let params = {
    functional_skill_id: functionalSkillID,
  };

  let config = {
    params: params,
  };

  return httpPost(url, config, token);
}

export function newFunctionalSkillSession(functionalSkillID, token) {
  return (dispatch) => {
    let url = `${Constants.BACKEND_URL}/start-new-functional-skill-session/`;
    let params = {
      functional_skill_id: functionalSkillID,
    };
    let config = {
      params: params,
    };
    httpPost(url, config, token).then(response =>{
        if(response.data.success){
            dispatch({
                type: actions.startedNewSkillSession,
                data: {[functionalSkillID]: response.data.new_functional_skill_session_id}
            })
        }
    })
  };
}

export function functionalSkills(token) {
  return (dispatch) => {
    const url = `${Constants.BACKEND_URL}/get-functional-skills/`;
    return httpGet(url, {}, token).then((response) => {
      if (typeof response !== "undefined") {
        if (response.data.success) {
          dispatch({
            type: actions.gotFunctionalSkills,
            data: response.data.functional_skills,
          });
        }
      }
    });
  };
}

const INITIAL_STATE = {
  functionalSkills: [],
  functionalSkillSessionIds: {}
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.gotFunctionalSkills:
      return {
        ...state,
        functionalSkills: [...action.data],
      };
    case actions.startedNewSkillSession:
        return {
            ...state,
            functionalSkillSessionIds: {...state.functionalSkillSessionIds, ...action.data}
        }
    default:
      return { ...state };
  }
}



// WEBPACK FOOTER //
// ./src/modules/functional_skills.js